import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 pt-16">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-foreground-400 mb-4">
            <i className="ri-emotion-sad-line text-3xl"></i>
          </div>
          <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-6">页面未找到</h1>
          <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-4 text-sm text-foreground-500">该页面不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex px-6 py-2.5 mt-6 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}